import PropTypes from 'prop-types';
import React from 'react';
import MessageBox from 'components/MessageBox';
import S from 'components/MessageBox/styles';
import { JOB_PAPERWORK_TEMPLATE_LABELS } from '../../jobPaperworkTemplateTypes';

export default class JobPaperworkWarning extends React.Component {
  static validate(templates, taskSlug) {
    if (!Array.isArray(templates)) return null;

    const completedTemplates = templates.filter(t => t.document_upload_id && !t.not_use);

    if (taskSlug === 'measure' && completedTemplates.length === 0) {
      return 'At least one completed template is required to complete the Measure task. Please complete a template using the IFI Template action button.';
    }
    return null;
  }

  handleMessage = (taskSlug, permitRequired) => {
    const validationError = JobPaperworkWarning.validate(this.props.templates, taskSlug);
    if (validationError) return validationError;

    if (taskSlug === 'workorder_complete' && permitRequired) {
      return 'Please verify that all required permits were completed in vendor gateway.';
    }
    return '';
  }

  render() {
    const { templates, taskSlug, templatesLoaded, templatesLoadError } = this.props;
    const defaultMessage = 'Please confirm that all required job paperwork (if any) is completed.';

    if (templatesLoaded === false) return null;

    if (templatesLoadError) {
      return <MessageBox error message="Unable to load job paperwork templates. Please try again." />;
    }

    if (!templates) return null;

    const completedTemplates = templates.filter(t => t.document_upload_id && !t.not_use);
    const permitRequired = this.props.permitRequired || false;

    const message = this.handleMessage(taskSlug, permitRequired);

    return (
      <MessageBox message={message || defaultMessage}>
        {completedTemplates.length > 0 && (
          <ul className={S.completedList}>
            {completedTemplates.map(t => (
              <li key={t.id}>
                <strong>{`Completed: ${JOB_PAPERWORK_TEMPLATE_LABELS[t.template_type] || t.template_type}`}</strong>
              </li>
            ))}
          </ul>
        )}
      </MessageBox>
    );
  }
}

JobPaperworkWarning.propTypes = {
  templates: PropTypes.array,
  taskSlug: PropTypes.string.isRequired,
  templatesLoaded: PropTypes.bool,
  templatesLoadError: PropTypes.bool,
  permitRequired: PropTypes.bool,
};

JobPaperworkWarning.defaultProps = {
  templatesLoaded: false,
  templatesLoadError: false,
  permitRequired: false,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/JobPaperworkWarning.jsx